import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone} from '@fortawesome/free-solid-svg-icons';


const ClientInfo = () => {
    return (
        <>
            <div className="bg-white rounded-lg shadow-lg border border-[#E6E3F6] overflow-hidden mx-8">
                {/* Header */}
                <div className="bg-[#9A48FF] text-white p-4 rounded-t-lg flex justify-between items-center">
                    <div className="flex items-center space-x-3">
                        <img
                            src="https://via.placeholder.com/40"
                            alt="Client"
                            className="w-10 h-10 rounded-full"
                        />
                        <h2 className="font-bold text-lg">Client Name</h2>
                    </div>
                    <button className="flex items-center space-x-2">
                        <FontAwesomeIcon icon={faPhone} />
                        <span>Call Client</span>
                    </button>
                </div>

                {/* Client Details */}
                <div className="p-4 space-y-3 text-tblue">
                    <div className="flex justify-between border-b pb-2">
                        <p className="font-semibold">Pet Name</p>
                        <p className="text-gray-600">Hobo Brown</p>
                    </div>
                    <div className="flex justify-between border-b pb-2">
                        <p className="font-semibold">Start Date</p>
                        <p className="text-gray-600">2 Jan, 2024</p>
                    </div>
                    <div className="flex justify-between border-b pb-2">
                        <p className="font-semibold">End Date</p>
                        <p className="text-gray-600">4 Jan, 2024</p>
                    </div>
                    <div className="flex justify-between border-b pb-2">
                        <p className="font-semibold">Service Provided</p>
                        <p className="text-gray-600">Pet Walk</p>
                    </div>
                    <div className="flex justify-between border-b pb-2">
                        <p className="font-semibold">Walk Feed Time</p>
                        <p className="text-gray-600">17:19</p>
                    </div>
                    <div className="flex justify-between">
                        <p className="font-semibold">Duration Walk</p>
                        <p className="text-gray-600">02:20</p>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg border border-[#E6E3F6] overflow-hidden mx-8">
                {/* Header */}
                <div className="bg-tblue text-white p-4 rounded-t-lg">
                    <h2 className="font-bold text-lg">Action</h2>
                </div>

                {/* Action List */}
                <div className="p-4 space-y-4 text-tblue">
                    <div className="flex justify-between items-center border-b pb-2">
                        <p className="font-semibold">Call Walker</p>
                        <div className="bg-purple-100 p-2 rounded-full">
                            <FontAwesomeIcon icon={faPhone} className="text-purple-500" />
                        </div>
                    </div>

                    <div className="border-b pb-2">
                        <p className="font-semibold">View Full Route History</p>
                    </div>

                    <div>
                        <p className="font-semibold">Mark as Delivered</p>
                    </div>

                    {/* Upload Button */}
                    <button className="bg-purple-500 text-white font-semibold w-full py-3 rounded-full mt-4">
                        Upload Image
                    </button>
                </div>
            </div>
        </>
    )
}

export default ClientInfo